export const playAudio =  (url: string) => {
  var audioFile = new Audio(url);
  audioFile.volume = 0.0
   audioFile.play().catch(console.error);
};

export const isPrime = (num: number) => {
  for (let i = 2; i < num; i++) if (num % i === 0) return false;
  return num > 1;
};

export const randomNumbersBetween = (a: number, b: number, evenprobability:number = 20) =>
{
  let number = Math.floor(Math.random() * b) + a
  let canBeEven = Math.floor(Math.random()*100)<=evenprobability 
  return  number === 2 || number === 0 || (number%2 || canBeEven)?number:number+1
}

export const primesBetween = (a: number, b: number) => {
  var sieve = [],
    i,
    j,
    primes = [];
  for (i = a || 2; i <= b; ++i) {
    if (!sieve[i]) {
      primes.push(i);
      for (j = i << 1; j <= b; j += i) {
        sieve[j] = true;
      }
    }
  }
  return primes;
};
